/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TipMi Admin API
 * Admin console backend API consumed by tipmi-admin-web
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AccountCreationRequestDTO,
  AccountSearchRequestDTO,
  AccountStatusRequestDTO,
  AccountUpdatingRequestDTO,
  GetAdminActivityLogParams,
  SuccessResponseDTOAccountViewResponseDTO,
  SuccessResponseDTOListRoleResponseDTO,
  SuccessResponseDTOPageResponseAccountViewResponseDTO,
  SuccessResponseDTOPageResponseActivityLogEntryDTO,
  SuccessResponseDTOVoid,
} from '.././model';

import { customInstance } from '../../http';

/**
 * @summary Search admin accounts
 */
export const searchAdminAccounts = (
  accountSearchRequestDTO: AccountSearchRequestDTO,
  signal?: AbortSignal,
) => {
  return customInstance<SuccessResponseDTOPageResponseAccountViewResponseDTO>({
    url: `/admin/api/account/search`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: accountSearchRequestDTO,
    ...(signal ? { signal } : {}),
  });
};

export const getSearchAdminAccountsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchAdminAccounts>>,
    TError,
    { data: AccountSearchRequestDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchAdminAccounts>>,
  TError,
  { data: AccountSearchRequestDTO },
  TContext
> => {
  const mutationKey = ['searchAdminAccounts'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchAdminAccounts>>,
    { data: AccountSearchRequestDTO }
  > = (props) => {
    const { data } = props ?? {};

    return searchAdminAccounts(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchAdminAccountsMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchAdminAccounts>>
>;
export type SearchAdminAccountsMutationBody = AccountSearchRequestDTO;
export type SearchAdminAccountsMutationError = unknown;

/**
 * @summary Search admin accounts
 */
export const useSearchAdminAccounts = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof searchAdminAccounts>>,
      TError,
      { data: AccountSearchRequestDTO },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof searchAdminAccounts>>,
  TError,
  { data: AccountSearchRequestDTO },
  TContext
> => {
  const mutationOptions = getSearchAdminAccountsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Create admin account
 */
export const createAdminAccount = (
  accountCreationRequestDTO: AccountCreationRequestDTO,
  signal?: AbortSignal,
) => {
  return customInstance<SuccessResponseDTOVoid>({
    url: `/admin/api/account/create`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: accountCreationRequestDTO,
    ...(signal ? { signal } : {}),
  });
};

export const getCreateAdminAccountMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAdminAccount>>,
    TError,
    { data: AccountCreationRequestDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAdminAccount>>,
  TError,
  { data: AccountCreationRequestDTO },
  TContext
> => {
  const mutationKey = ['createAdminAccount'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAdminAccount>>,
    { data: AccountCreationRequestDTO }
  > = (props) => {
    const { data } = props ?? {};

    return createAdminAccount(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAdminAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAdminAccount>>
>;
export type CreateAdminAccountMutationBody = AccountCreationRequestDTO;
export type CreateAdminAccountMutationError = unknown;

/**
 * @summary Create admin account
 */
export const useCreateAdminAccount = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createAdminAccount>>,
      TError,
      { data: AccountCreationRequestDTO },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createAdminAccount>>,
  TError,
  { data: AccountCreationRequestDTO },
  TContext
> => {
  const mutationOptions = getCreateAdminAccountMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update admin account
 */
export const updateAdminAccount = (accountUpdatingRequestDTO: AccountUpdatingRequestDTO) => {
  return customInstance<SuccessResponseDTOVoid>({
    url: `/admin/api/account/update`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: accountUpdatingRequestDTO,
  });
};

export const getUpdateAdminAccountMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAdminAccount>>,
    TError,
    { data: AccountUpdatingRequestDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAdminAccount>>,
  TError,
  { data: AccountUpdatingRequestDTO },
  TContext
> => {
  const mutationKey = ['updateAdminAccount'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAdminAccount>>,
    { data: AccountUpdatingRequestDTO }
  > = (props) => {
    const { data } = props ?? {};

    return updateAdminAccount(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAdminAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAdminAccount>>
>;
export type UpdateAdminAccountMutationBody = AccountUpdatingRequestDTO;
export type UpdateAdminAccountMutationError = unknown;

/**
 * @summary Update admin account
 */
export const useUpdateAdminAccount = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateAdminAccount>>,
      TError,
      { data: AccountUpdatingRequestDTO },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateAdminAccount>>,
  TError,
  { data: AccountUpdatingRequestDTO },
  TContext
> => {
  const mutationOptions = getUpdateAdminAccountMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Change account status
 */
export const changeAdminStatus = (accountStatusRequestDTO: AccountStatusRequestDTO) => {
  return customInstance<SuccessResponseDTOVoid>({
    url: `/admin/api/account/change-status`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: accountStatusRequestDTO,
  });
};

export const getChangeAdminStatusMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeAdminStatus>>,
    TError,
    { data: AccountStatusRequestDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changeAdminStatus>>,
  TError,
  { data: AccountStatusRequestDTO },
  TContext
> => {
  const mutationKey = ['changeAdminStatus'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changeAdminStatus>>,
    { data: AccountStatusRequestDTO }
  > = (props) => {
    const { data } = props ?? {};

    return changeAdminStatus(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangeAdminStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof changeAdminStatus>>
>;
export type ChangeAdminStatusMutationBody = AccountStatusRequestDTO;
export type ChangeAdminStatusMutationError = unknown;

/**
 * @summary Change account status
 */
export const useChangeAdminStatus = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof changeAdminStatus>>,
      TError,
      { data: AccountStatusRequestDTO },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof changeAdminStatus>>,
  TError,
  { data: AccountStatusRequestDTO },
  TContext
> => {
  const mutationOptions = getChangeAdminStatusMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary View account detail
 */
export const viewAdminAccount = (adminId: number, signal?: AbortSignal) => {
  return customInstance<SuccessResponseDTOAccountViewResponseDTO>({
    url: `/admin/api/account/view-detail/${adminId}`,
    method: 'GET',
    ...(signal ? { signal } : {}),
  });
};

export const getViewAdminAccountQueryKey = (adminId?: number) => {
  return [`/admin/api/account/view-detail/${adminId}`] as const;
};

export const getViewAdminAccountQueryOptions = <
  TData = Awaited<ReturnType<typeof viewAdminAccount>>,
  TError = unknown,
>(
  adminId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof viewAdminAccount>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getViewAdminAccountQueryKey(adminId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof viewAdminAccount>>> = ({ signal }) =>
    viewAdminAccount(adminId, signal);

  return { queryKey, queryFn, enabled: !!adminId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof viewAdminAccount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ViewAdminAccountQueryResult = NonNullable<Awaited<ReturnType<typeof viewAdminAccount>>>;
export type ViewAdminAccountQueryError = unknown;

export function useViewAdminAccount<
  TData = Awaited<ReturnType<typeof viewAdminAccount>>,
  TError = unknown,
>(
  adminId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof viewAdminAccount>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewAdminAccount>>,
          TError,
          Awaited<ReturnType<typeof viewAdminAccount>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useViewAdminAccount<
  TData = Awaited<ReturnType<typeof viewAdminAccount>>,
  TError = unknown,
>(
  adminId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof viewAdminAccount>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewAdminAccount>>,
          TError,
          Awaited<ReturnType<typeof viewAdminAccount>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useViewAdminAccount<
  TData = Awaited<ReturnType<typeof viewAdminAccount>>,
  TError = unknown,
>(
  adminId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof viewAdminAccount>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary View account detail
 */

export function useViewAdminAccount<
  TData = Awaited<ReturnType<typeof viewAdminAccount>>,
  TError = unknown,
>(
  adminId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof viewAdminAccount>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getViewAdminAccountQueryOptions(adminId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete admin account
 */
export const deleteAdminAccount = (adminId: number) => {
  return customInstance<SuccessResponseDTOAccountViewResponseDTO>({
    url: `/admin/api/account/delete/${adminId}`,
    method: 'DELETE',
  });
};

export const getDeleteAdminAccountMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAdminAccount>>,
    TError,
    { adminId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAdminAccount>>,
  TError,
  { adminId: number },
  TContext
> => {
  const mutationKey = ['deleteAdminAccount'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAdminAccount>>,
    { adminId: number }
  > = (props) => {
    const { adminId } = props ?? {};

    return deleteAdminAccount(adminId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAdminAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAdminAccount>>
>;

export type DeleteAdminAccountMutationError = unknown;

/**
 * @summary Delete admin account
 */
export const useDeleteAdminAccount = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAdminAccount>>,
      TError,
      { adminId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAdminAccount>>,
  TError,
  { adminId: number },
  TContext
> => {
  const mutationOptions = getDeleteAdminAccountMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary List assignable admin roles
 */
export const listAdminRoles = (signal?: AbortSignal) => {
  return customInstance<SuccessResponseDTOListRoleResponseDTO>({
    url: `/admin/api/account/roles`,
    method: 'GET',
    ...(signal ? { signal } : {}),
  });
};

export const getListAdminRolesQueryKey = () => {
  return [`/admin/api/account/roles`] as const;
};

export const getListAdminRolesQueryOptions = <
  TData = Awaited<ReturnType<typeof listAdminRoles>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRoles>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAdminRolesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminRoles>>> = ({ signal }) =>
    listAdminRoles(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAdminRoles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListAdminRolesQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminRoles>>>;
export type ListAdminRolesQueryError = unknown;

export function useListAdminRoles<
  TData = Awaited<ReturnType<typeof listAdminRoles>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRoles>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminRoles>>,
          TError,
          Awaited<ReturnType<typeof listAdminRoles>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListAdminRoles<
  TData = Awaited<ReturnType<typeof listAdminRoles>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRoles>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminRoles>>,
          TError,
          Awaited<ReturnType<typeof listAdminRoles>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListAdminRoles<
  TData = Awaited<ReturnType<typeof listAdminRoles>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRoles>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List assignable admin roles
 */

export function useListAdminRoles<
  TData = Awaited<ReturnType<typeof listAdminRoles>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRoles>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListAdminRolesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Admin account activity log
 */
export const getAdminActivityLog = (
  adminId: number,
  params?: GetAdminActivityLogParams,
  signal?: AbortSignal,
) => {
  return customInstance<SuccessResponseDTOPageResponseActivityLogEntryDTO>({
    url: `/admin/api/account/${adminId}/activity-log`,
    method: 'GET',
    params,
    ...(signal ? { signal } : {}),
  });
};

export const getGetAdminActivityLogQueryKey = (
  adminId?: number,
  params?: GetAdminActivityLogParams,
) => {
  return [`/admin/api/account/${adminId}/activity-log`, ...(params ? [params] : [])] as const;
};

export const getGetAdminActivityLogQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminActivityLog>>,
  TError = unknown,
>(
  adminId: number,
  params?: GetAdminActivityLogParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAdminActivityLog>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminActivityLogQueryKey(adminId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminActivityLog>>> = ({ signal }) =>
    getAdminActivityLog(adminId, params, signal);

  return { queryKey, queryFn, enabled: !!adminId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminActivityLog>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAdminActivityLogQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminActivityLog>>
>;
export type GetAdminActivityLogQueryError = unknown;

export function useGetAdminActivityLog<
  TData = Awaited<ReturnType<typeof getAdminActivityLog>>,
  TError = unknown,
>(
  adminId: number,
  params: undefined | GetAdminActivityLogParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAdminActivityLog>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminActivityLog>>,
          TError,
          Awaited<ReturnType<typeof getAdminActivityLog>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAdminActivityLog<
  TData = Awaited<ReturnType<typeof getAdminActivityLog>>,
  TError = unknown,
>(
  adminId: number,
  params?: GetAdminActivityLogParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAdminActivityLog>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminActivityLog>>,
          TError,
          Awaited<ReturnType<typeof getAdminActivityLog>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAdminActivityLog<
  TData = Awaited<ReturnType<typeof getAdminActivityLog>>,
  TError = unknown,
>(
  adminId: number,
  params?: GetAdminActivityLogParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAdminActivityLog>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Admin account activity log
 */

export function useGetAdminActivityLog<
  TData = Awaited<ReturnType<typeof getAdminActivityLog>>,
  TError = unknown,
>(
  adminId: number,
  params?: GetAdminActivityLogParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAdminActivityLog>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAdminActivityLogQueryOptions(adminId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
